import { API_URL } from "config";
import Http from "util/https";
import { CSVConfirmResponseApi, CSVUploadCountParam, CSVUploadCheckParam } from "../types/index";

/**
 * 商品CSV確認更新Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns {Promise<CSVConfirmResponseApi>} CSVCountCheckOrder[]
 */
export default async function getCsvConfirmApi(
  params: CSVUploadCountParam,
): Promise<CSVConfirmResponseApi> {
  console.log('getCsvConfirmApi params:', params);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/csv/upload`;
  const res = await http.post<CSVConfirmResponseApi>(url, Http.convertObjectToFormData(params));
  console.log(res);

  return res.data;
}
